import { EventEmitter } from 'node:events';

/**
 * Event emitter for command lifecycle events. Not all events are applicable to all commands.
 *
 * This event emitter provides a reliable mechanism for coordinating test execution
 * with server initialization, ensuring that test assertions only run after all
 * necessary services are fully operational.
 *
 * Events:
 * - `'ready'`: An interactive command is ready.
 *   - For `start`, all servers are ready (and browser opening has started).
 */
export type CommandEvents = EventEmitter<{ ready: [] }>;

/**
 * Create an event emitter for command lifecycle events. Not all events are applicable to all commands.
 * @see {@link CommandEvents}
 */
export function createCommandEvents(): CommandEvents {
  return new EventEmitter();
}
